module.exports = __webpack_public_path__ + "static/media/move-down.87f934a5.svg";